export default __webpack_public_path__ + "img/349ee62e02a6ca1c94f5fc607ee05ca0.svg";